// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TdJMS","top":"styles_top__3akSV","left":"styles_left__6v-2y","description":"styles_description__1WOVc"};